import { Model } from './Model'
import { Product } from './Product'
import { BatteryDataType, IdType } from '@/types'

export class Battery extends Model {
    raw: BatteryDataType

    product_id: IdType

    warranty_id: IdType

    size_kw: number

    size_w: number

    serial_number: string[]

    product: Product

    constructor(data: BatteryDataType) {
        super(data)
        this.raw = data
        this.product_id = data.product_id
        this.warranty_id = data.warranty_id
        if (Array.isArray(data.serial_number)) {
            this.serial_number = data.serial_number
        } else if (typeof data.serial_number === 'string' && data.serial_number) {
            this.serial_number = data.serial_number.split(',').map(item => item.trim())
        } else {
            this.serial_number = []
        }
        this.size_kw = Model.toNumber(data.size_kw) as number
        this.size_w = Model.toNumber(data.size_w) as number
        this.product = new Product(data.product)
    }
}
